<div>
    <div class="card-header d-flex flex-column" style="gap: 1rem;">
        <div style="font-family: 'Lato';" *ngIf="title != '' || description != ''"
            class="m-1 d-flex align-items-baseline justify-content-start flex-column flex-sm-column text-left flex-wrap">
            <h2 style="color:#404b5a" *ngIf="title != ''" class="m-0 mr-2">{{title | slice:0:100 | uppercase}}</h2>
            <small *ngIf="description != ''" class="title-description">{{description |
                slice:0:200}}</small>
        </div>
        <form [formGroup]="form">

            <div style="display: grid;  grid-template-columns: repeat(2, 1fr);">
                <mat-form-field appearance="fill" style="padding :20px;">
                    <mat-label>Estado</mat-label>
                    <mat-select formControlName="estado">
                        <mat-option *ngFor="let tienda of state" [value]="tienda">
                            {{tienda == "A" ? "Activo":"Inactivo"}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="padding :20px;">
                    <mat-label>Tienda</mat-label>
                    <input matInput [matAutocomplete]="autoTienda" formControlName="tienda"
                        (keyup)="storeFilter($event)">
                    <mat-autocomplete #autoTienda="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let tienda of storesFiltered" [value]="tienda">
                            {{tienda['C_AGE']}} - {{tienda['NOM']}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="fill" style="padding :20px;">
                    <mat-label>Caja Rapida</mat-label>
                    <mat-select formControlName="cajarap">
                        <mat-option *ngFor="let tienda of state" [value]="tienda == 'I'?'N':'S'">
                            {{tienda == "A" ? "Aplica":"No Aplica"}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="padding: 20px;">
                    <mat-label>Tipo Cajero</mat-label>
                    <mat-select formControlName="t_cajero">
                        <mat-option *ngFor="let type of types_cash" [value]="type">
                            {{type === 'P' ? 'Principal' : (type === 'S' ? 'Secundario' : 'Auxiliar')}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


            </div>
            <div class="card-footer d-flex align-items-center justify-content-end gap-2">
                <button mat-flat-button class="btn_cancel" type="button" (click)="close()">Cancelar</button>
                <button mat-flat-button type="submit" class="btn_save" (click)="save()">Guardar</button>

            </div>
        </form>
    </div>



</div>